<span *ngIf="showUser">{{ prefix }}{{ userString }}{{ suffix }}</span>
